import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { ActivatedRoute } from '@angular/router';
import { DataService } from '../services/data.service';
import { Order } from '../order/interfaces/order';
import { MatPaginator, MatSort, PageEvent } from '@angular/material';
import { DataSource } from '@angular/cdk/table';
import { OrderEntryComponent } from '../order/components/order-entry.component';
import { Budget } from '../budget/interfaces';
import { MaterialItem } from './interfaces/material-item';

import { Angular5Csv } from 'angular5-csv/dist/Angular5-csv';

@Component({
  selector: 'app-materials-list',
  templateUrl: './materials-list.component.html',
  styleUrls: ['./materials-list.component.scss']
})
export class MaterialsListComponent implements OnInit, OnDestroy {

  public triggerRefresh = new BehaviorSubject<boolean>(false);
  private materialList = new BehaviorSubject<Order[]>([]);
  public materialList$: Observable<any[]>;
  public budgetId;

  public budget$: Observable<Budget>;
  public materialTotalCost: Observable<number>;

  private subscription;
  private renderedData: any;

  constructor(
    private dataService: DataService,
    private route: ActivatedRoute) { }

  ngOnInit() {
    this.subscription = Observable.combineLatest(
    this.route.paramMap,
    this.triggerRefresh
  )
    .switchMap(([params, trigger]) => {
      this.budgetId = params.get('budgetId');

      this.budget$ = this.dataService.getSimpleBudget(this.budgetId);

      return this.dataService.getOrdersByBudget(this.budgetId);
    })
    .subscribe(this.materialList);


    this.materialList$ = this.materialList
    .map((orders: Order[]) => {

      const flatMat = [];

      for (const order of orders) {
        for (const item of order.items) {
          if (item.budget.id === this.budgetId) {
            const el: MaterialItem = {
              item,
              orderId: order.id,
              orderNr: order.orderNr,
              date: <Date>order.date,
              deleted: order.deleted,
              author: order.author.displayName,
              vendor: order.vendor.name,
              total: OrderEntryComponent.calculateEntryValue(item)
            };
            flatMat.push(el);
          }

        }
      }

      this.materialTotalCost = this.materialList$.map((list) =>  list.map(i => i.total).reduce((a, b) => a + b, 0));

      return flatMat;
    });


  }

  updateRenderedData(e){
    this.renderedData = e;
  }

  exportCsv() {
    const report = new Angular5Csv(this.renderedData, 'Test Report', {
      decimalseparator: ',',
      fieldSeparator: ';'
    });
  }
  public refresh = () => {
    this.triggerRefresh.next(true);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}




// WEBPACK FOOTER //
// ./src/app/balances/materials-list.component.ts